<template>
  <div class="kpt-health kpt-single-page">
    <vue-headful title="System Health" />
    <header class="kpt-single-header">
      <h4>System Health</h4>
    </header>
    <div class="kpt-system-health p-4" v-if="systemHealth">
      <div class="kpt-detail-content-actions mb-2">
        <b-button type="is-primary is-outlined" icon-left="sync-alt" size="is-small" :loading="isRefreshing" :disabled="isRefreshing" @click="refreshHealth">Refresh</b-button>
      </div>
      <p class="mb-2">{{systemHealth.description}}</p>
      <detail-field>
        <template v-slot:label>Overall Status</template>
        <template v-slot:value>
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-success" v-if="overallHealth === 'Healthy'" title="Healthy" />
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-warning" v-else-if="overallHealth === 'Degraded'" title="Degraded" />
          <font-awesome-icon :icon="['far', 'circle']" class="has-text-danger" v-else title="Unhealthy" />
          {{overallHealth}}</template>
      </detail-field>
      <hr />
      <pre>{{ overallHealth }}</pre>
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th style="width: 200px">Code</th>
            <th style="width: 200px">Service</th>
            <th>Version</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, key) in systemHealth" :key="key">
            <td>{{ value.Item1 }}</td>
            <td>{{ key }}</td>
            <td>{{ JSON.parse(value.Item2)?.Version }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <b-table :data="systemHealth.values">
        <b-table-column field="service" label="Service" v-slot="props" width="200">
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-success" v-if="props.row.code === 200" title="OK" />
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-danger" v-else title="NOT OK" />
          {{ props.row.code }}
        </b-table-column>
        <b-table-column field="service" label="Service" v-slot="props" width="200">
          {{ props.row.service }}
        </b-table-column>
        <b-table-column field="version" label="Version" v-slot="props">
          {{ props.row.version }}
        </b-table-column>
      </b-table> -->
    </div>
    <div class="p-4" v-else>
      <p>System Health couldn't load.</p>
    </div>
  </div>
</template>
<script>
import { ref, computed, getCurrentInstance } from 'vue';

export default {
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const systemHealth = computed(() => root.$store.state.appStatus);
    // eslint-disable-next-line no-nested-ternary
    const overallHealth = computed(() => (systemHealth.value ? Object.values(systemHealth.value).map(v => v.Item1).every(s => s == 200) ? 'Healthy' : 'Degraded' : 'Unhealthy'))
    const isRefreshing = ref(false);

    const refreshHealth = async () => {
      isRefreshing.value = true;
      await root.$store.dispatch('fetchAppStatus');
      isRefreshing.value = false;
    }

    refreshHealth();

    return {
      systemHealth,
      overallHealth,
      refreshHealth,
      isRefreshing
    }
  }
}
</script>
